'use client';
import UniversalReport from '@tencent/universal-report';
import { useIsomorphicLayoutEffect } from 'react-use';
import { useSiblingStore } from './useSiblingStore';
import { useMedia } from './useMedia';

let reporter: UniversalReport;

// 登录态未就绪时暂存的 user_id 公参值（SDK 单例创建后会补写）
let pendingUserId: string | null | undefined = undefined;

function applyUserId(userId: string | null) {
  if (!reporter) return;
  if (userId) {
    reporter.setPublicParams({ user_id: userId });
  } else {
    reporter.removePublicParams('user_id');
  }
}

/**
 * 登录态变化时同步 user_id 公参（大同 2024 方案已登记该公参）。
 * - 登录成功：写入用户 GUID；
 * - 登出 / 会话失效：移除，回到匿名口径。
 * SDK 单例尚未创建时会先暂存，创建后自动补写。
 */
export function syncDatongUserId(userId?: string | null) {
  pendingUserId = userId ?? null;
  if (reporter) {
    applyUserId(pendingUserId);
  }
}

export function useDatong() {
  useMedia('mobile');
  useIsomorphicLayoutEffect(() => {
    const unsub = useSiblingStore.subscribe(
      (state) => state.mediaQuery,
      (mediaQuery) => {
        if (mediaQuery !== 'idle') {
          if (!reporter) {
            reporter = new UniversalReport({
              beacon: process.env.NEXT_PUBLIC_DATONG_ID, // 灯塔 APPKEY 或者灯塔实例
              publicParams: {
                is_test: process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 0 : 1,
              },
            });
            // 补写登录态先于 SDK 就绪时的 user_id 公参
            if (pendingUserId !== undefined) {
              applyUserId(pendingUserId);
            }
          }
        }
      },
      {
        fireImmediately: true,
      }
    );
    return unsub;
  }, []);

  return reporter;
}

export function getDatong() {
  return reporter;
}
